import { IDRegistrationType } from "interfaces/Database";
import apiService from "./api.service";

class RegistrationTypeService {
    public async getAllRegistrationTypes() {
        return await apiService.makeApiCall<IDRegistrationType[]>('/api/registrationType', 'get');
    }
}

export default new RegistrationTypeService();